<!--<button class="btn btn-secondary" 
[class.verte]="isVerte"
(click)="changerCouleur()"
>bonjour</button>[class.verte] permet d'affecter une classe sous condition "isVerte--->

<div class="row justify-content-between">
    <div *ngFor="let chaqueGateau of leRayonnage" class="card mt-5" style="width: 20rem;">
        <img src="{{chaqueGateau.image}}" class="card-img-top"
            alt="...">
        <div class="card-body">
            <h5 class="card-title h2">{{chaqueGateau.nom.charAt(0).toUpperCase()+ chaqueGateau.nom.slice(1)}}</h5>
            <p class="card-text ">{{chaqueGateau.description}}</p>
            <app-details-gateaux [gout]="chaqueGateau.gout"
            [tempsDePrep]="chaqueGateau.tempsPreparation"
            [valeurCalorique]="chaqueGateau.calories"
            ></app-details-gateaux>
            <div class="row justify-content-between p-2">
            <app-gateau-deja-mange [dejaMange]="chaqueGateau.mangeOuNon"></app-gateau-deja-mange>
        <button
        (click)="ajouterUnGateauAuPanier(chaqueGateau)"
        class="btn btn-success p-2">Ajouter au panier</button>
        </div>
    </div>
    </div>
  
</div>
